export default __webpack_public_path__ + "static/media/ArrowLeftIcon.25f8cb54.svg";